module.exports = __webpack_public_path__ + "16c8a36f748e8090fb37ea40a205f9be.png";